export const initReadMore = function () {
  const linkMore = document.querySelectorAll('.sectors__link-more');

  if (linkMore) {
    linkMore.forEach((item) => {
      item.addEventListener('click', function (evt) {
        evt.preventDefault();

        let parent = item.closest('.sectors__item');
        if (parent.closest('.is-show')) {
          parent.classList.remove('is-show');
        } else {
          let sectors = document.querySelectorAll('.sectors__item');
          sectors.forEach((i) => {
            if (i.closest('.is-show')) {
              i.classList.remove('is-show');
            }
          });
          // let positionPage = parent.offsetTop;
          // let positionPage = window.pageXOffset;
          // console.log(positionPage);

          parent.classList.add('is-show');
          const indentPage = -100 + `px`;
          parent.scrollIntoView(indentPage);

        }
      })
    })
  }
};
